import menu from './menu';
import notifications from './notifications';
import moment from 'moment';

const currentMonthrange = moment().startOf('month').format('YYYY-MM-DD') + ',' + moment().endOf('month').format('YYYY-MM-DD');

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/news_posts': {
                params: { sort: 'available_at:desc', append: 'category_list' }
            },
            '^/staff_members': {
                params: { sort: 'position:desc', append: 'branch_list' }
            },
            '^/villages': {
                params: { sort: 'position:asc' }
            },
            '^/videos': {
                params: { sort: 'position:asc' }
            },
            '^/enquiries': {
                params: { sort: 'created_at:desc' }
            },

        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            mp4: ['mp4', 'webm'],
            csv: ['csv'],
            mod: ['mod'],
            dwg: ['dwx', 'dwg'],
        }
    },
    menu,
    notifications,
    inboxActive: false,
}
